var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewApproach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2746_2589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36 2.66675C40.032 7.97608 41.62 14.8987 32.064 22.1547C28.032 16.8454 25.3814 10.7294 36 2.66675Z",
    fill: "#FFE87C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6665 17.8933H30.6665V41.8933H34.6665V17.8933Z",
    fill: "#FFE87C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.6665 44H12.5492C15.7625 44 18.7118 45.836 20.1625 48.768L23.1092 54.728C23.8878 56.3013 24.9292 57.3333 26.6665 57.3333H38.6665C40.4038 57.3333 41.4318 56.3027 42.2105 54.728L45.1572 48.768C46.6078 45.836 49.5572 44 52.7705 44H61.3332V61.3333H2.6665V44Z",
    fill: "#FADA45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6665 41.3333L24.4852 49.7866C25.2892 51.9199 27.2678 53.3333 29.4758 53.3333H35.8572C38.0638 53.3333 40.0438 51.9199 40.8465 49.7866L42.6665 41.3333H22.6665Z",
    fill: "#FFE87C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 22.6667C16 29.3334 18.6667 36.0001 30.6667 36.0001C30.6667 29.3334 29.3333 22.6667 16 22.6667ZM49.3333 18.6667C49.3333 25.3334 46.6667 32.0001 34.6667 32.0001C34.6667 25.3334 36 18.6667 49.3333 18.6667Z",
    fill: "#FFE87C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2746_2589"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewApproach);
export default __webpack_public_path__ + "static/media/new_approach.127ca467.svg";
export { ForwardRef as ReactComponent };